import {
  useReduceWithModel,
  IModel,
} from '@/hooks/useReduceWithModel/useReduceWithModel';
import { IFetchGoodsList, IFetchCouponList } from '@/services/atmosphereTypes';

interface IGoodList extends IFetchGoodsList {
  appletNeedHide: boolean;
  needRedirect: boolean;
  redirectUrl: string;
  goodsPayMode: string;
  preparePrice: number;
  productId: number;
  unshelf: boolean;
  saleAble: boolean;
}

interface IState {
  // 商品列表
  goodsList: Array<IGoodList>;
  // 购物车
  cartNumber: number;
  // 待付金额;
  totalAmount: number;
  // 多规格弹窗;
  specsGoodsId: number | undefined;
  couponList: Array<IFetchCouponList>;
}

const initialState: IState = {
  goodsList: [],
  cartNumber: 0,
  totalAmount: 0,
  specsGoodsId: undefined,
  couponList: [],
};

/**
 * 可以直接返回state，也可以修改draft里面的数据，返回空
 * @param draft
 * @param action
 */

enum actionEnum {
  initalial = 'initalial',
  reset = 'reset',
  increment = 'increment',
  decrement = 'decrement',
  totalAmount = 'totalAmount',
  cartNumber = 'cartNumber',
  specs = 'specs',
  coupon = 'coupon',
}

const model: IModel<IState> = {
  immer: true,
  state: initialState,
  reducers: {
    [actionEnum.initalial](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        goodsList: action.payload,
      };
    },
    [actionEnum.increment](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      const goodsList = [...state.goodsList];
      const goodsIndex = goodsList.findIndex(
        item => item.goodsId === action.payload.goodsId,
      );
      if (goodsIndex > -1) {
        const goods = goodsList[goodsIndex];
        goodsList[goodsIndex] = {
          ...goods,
          cartNum: action.payload.num,
          productId: action.payload.productId,
        };
        return {
          ...state,
          goodsList,
        };
      }
      return state;
    },
    [actionEnum.totalAmount](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        totalAmount: action.payload,
      };
    },
    [actionEnum.cartNumber](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        cartNumber: action.payload,
      };
    },
    [actionEnum.specs](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        specsGoodsId: action.payload,
      };
    },
    [actionEnum.coupon](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        couponList: action.payload,
      };
    },
  },
};

const useAtmosphereDetailsModel = () => {
  const [state, dispatch] = useReduceWithModel(model);
  // 缓存商品列表
  const initalial = (goodsList: Array<IFetchGoodsList>) =>
    dispatch({ type: actionEnum.initalial, payload: goodsList });
  const reset = () => dispatch({ type: actionEnum.reset });
  // 点击修改购物车数量
  const increment = (payload: any) =>
    dispatch({ type: actionEnum.increment, payload });
  const decrement = (num = 1) =>
    dispatch({ type: actionEnum.decrement, payload: num });
  // 缓存订单金额;
  const totalAmount = (num = 0) =>
    dispatch({ type: actionEnum.totalAmount, payload: num });
  // 缓存购物车数量
  const cartNumber = (num = 0) =>
    dispatch({ type: actionEnum.cartNumber, payload: num });
  // 商品的id
  const specs = (id = 0) => dispatch({ type: actionEnum.specs, payload: id });
  // 优惠券
  const coupon = (couponList: any) =>
    dispatch({ type: actionEnum.coupon, payload: couponList });
  const badAction = () => dispatch({ type: 'some action' });
  return {
    state,
    initalial,
    reset,
    increment,
    decrement,
    badAction,
    cartNumber,
    totalAmount,
    specs,
    coupon,
  };
};

export default useAtmosphereDetailsModel;
